<finxone-web-frontend-currency-listing
  class="h-100"
  [widgetAttributes]="widgetAttributes"
  [contentStyle]="contentStyle"
  [textContentStyle]="textContentStyle"
  [searchIconStyle]="searchIconStyle"
></finxone-web-frontend-currency-listing>
